import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SearchResultPage } from './search-result.page';
import { SharedModule } from '../shared-module/shared.module';
import { SearchResultPageRoutingModule } from './search-result-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    CommonModule,
    SharedModule,
    SearchResultPageRoutingModule
  ],
  declarations: [SearchResultPage]
})
export class SearchResultPageModule { }
